<template>
    <popup-modal show>
        <template #content>
            <div class="message">
                <h3>Begin een pot JP</h3>
            </div>
            <div class="message secundary">
                <p>Kies bestaande of nieuwe spelers</p>
            </div>
            <transition-group name="slide-inputs" class="game-users flex-column-gap">
                <div class="actions-bar" key="action-bar">
                    <custom-select 
                        variation="white"
                        v-model="manuallySelectedUserIds"
                        :options="userOptions" 
                        multiple
                        arrow
                        :favorites="!!you"
                        @toggleFavorite="handleUserFavoriteToggled"
                        @input="handleUserSelected"
                    >Selecteer uit lijst</custom-select>
                    <custom-button class="custom-button" size="medium" @click="handleStartGame" :disabled="allGameUsers.length < 3">START</custom-button>
                </div>
                <div 
                    v-for="user in allGameUsers" 
                    :key="user.keyId" 
                    class="game-user blur-focus" 
                    :class="{ 'enabled':  suggestedUsers.length > 0 }" 
                    @click="handleUserRowSelected(user)"
                >
                    <div class="custom-input" :class="{ empty: !user.name }" :id="`user-${user.keyId}`">
                        <div v-if="!user.exists" class="suggested-users">
                            <div v-for="(suggestion, index) in suggestedUsers" :key="suggestion.keyId" class="suggested-user" :class="{ selecting: selectingUserId === suggestion.id }" :style="`--index: ${index}`" @click="handleSuggestionSelected(suggestion.name, user)">
                                <p v-parse-emojis class="name">{{ suggestion.name }}</p>
                            </div>
                        </div>
                        <input 
                            v-model="user.name"
                            type="text" 
                            placeholder="+ Nieuwe speler registreren" 
                            class="name-input name"
                            :class="{ 'existing-user': user.exists }"
                            :disabled="user.exists"
                            @keydown.enter="focusNextInput"
                            @keydown="validateInput($event, user)"
                            @input="handleNameInput($event, user)"
                        >
                        <div v-if="user.name && !selectingUserId && !user.isYou" class="remove-icon" @click.stop="handleRemoveUser(user)">
                            <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"/></svg>
                        </div>
                    </div>
                </div>
            </transition-group>
        </template>
    </popup-modal>
</template>

<script>
import PopupModal from '@/components/PopupModal.vue';
import CustomButton from '@/components/CustomButton.vue';
import CustomSelect from '@/components/CustomSelect.vue';

const { v4: uuidv4 } = require('uuid');
import _ from 'lodash';
import { httpRequest } from '@/utils.js';

export default {
    name: 'create-game',
    components: {
        PopupModal,
        CustomButton,
        CustomSelect
    },
    props: {
        users: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            newGameUsers: [
                {
                    id: uuidv4(),
                    keyId: uuidv4(),
                    name: ''
                }
            ],
            gameUsers: [],
            suggestedUsers: [],
            manuallySelectedUserIds: [],
            manuallyChoosing: false,
            selectingUserId: null,
            you: null,
            favoriteUserIds: []
        }
    },
    methods: {
        validateInput(event, newUser) {
            const text = event.target.value;
            const letter = event.key;
            if(text.length !== 0 || letter.length !== 1 || !letter.match(/[a-z]/i)) return

            event.preventDefault();
            const index = this.newGameUsers.findIndex(user => user.keyId === newUser.keyId);
            this.newGameUsers[index].name = letter.toUpperCase();
            
            this.handleUpdatePlaceholder(letter, newUser);
            this._handleAddNewUser();
        },
        handleNameInput(event, newUser) {
            const name = event.target.value.trim();
            if (!name) this.removeDuplicateEmptyFields();
            this.handleUpdatePlaceholder(name, newUser);
            this._handleSelectSuggested(name, newUser);
            this._handleAddNewUser();
        },
        removeDuplicateEmptyFields() {
            let emptyUsers = 0;
            this.newGameUsers = this.newGameUsers.filter(user => {
                if (user.name) return true;
                if (emptyUsers !== 0) return false;
                emptyUsers++;
                return true;
            });
        },
        _handleSelectSuggested: _.debounce(function(name, newUser) {
            if(!this.selectingUserId || this.suggestedUsers.length === 0) return

            this.handleSuggestionSelected(newUser.name, newUser);
        }, 1500),
        _handleAddNewUser: _.debounce(function() {
            this.handleAddNewUser();
        }, 200),
        handleUpdatePlaceholder(name, newUser) {
            if(name === '') return this.suggestedUsers = [];

            name = name.toLowerCase();
            const matchingUsers = this.users.filter(user => 
                user.name.toLowerCase().includes(name.toLowerCase()) && 
                !this.manuallySelectedUserIds.includes(user.id) && 
                user.id !== this.you?.id
            );
            this.suggestedUsers = matchingUsers;
            if(this.suggestedUsers.length === 0) return this.selectingUserId = null;

            if(name !== matchingUsers[0].name.toLowerCase()) this.selectingUserId = null;
            else this.selectingUserId = matchingUsers[0].id;
        },
        handleAddNewUser() {
            const hasUserWithoutName = this.newGameUsers.some(user => user.name === '');
            if(hasUserWithoutName) return

            this.newGameUsers.push({
                id: uuidv4(),
                keyId: uuidv4(),
                name: ''
            })
        },
        handleSuggestionSelected(name, user) {
            this.selectingUserId = null;
            name = name.toLowerCase();
            const suggestion = this.suggestedUsers[0];
            if(name === suggestion.name.toLowerCase()) this.handleUseSuggestedUser(user, suggestion);

            this.focusNextInput();
        },
        handleUseSuggestedUser(user, suggestedUser) {
            this.manuallySelectedUserIds.push(suggestedUser.id);
            this.newGameUsers = this.newGameUsers.map(gameUser => {
                if(gameUser.id === user.id) return { ...suggestedUser, keyId: user.keyId }
                return gameUser
            })
            this.suggestedUsers = [];
        },
        handleRemoveUser(user) {
            this.gameUsers = this.gameUsers.filter(gameUser => gameUser.keyId !== user.keyId);
            this.newGameUsers = this.newGameUsers.filter(gameUser => gameUser.keyId !== user.keyId);
            this.manuallySelectedUserIds = this.manuallySelectedUserIds.filter(id => id !== user.id);
        },
        handleUserRowSelected(user) {
            if (!user.name) return;
            
            this.manuallySelectedUserIds.push(user.id);
            this.handleUserSelected();
        },
        async handleUserFavoriteToggled(userId) {
            let favoriteUserIds = localStorage.getItem('favoriteUserIds');
            if (favoriteUserIds) favoriteUserIds = JSON.parse(favoriteUserIds);
            else favoriteUserIds = [];

            if (favoriteUserIds.includes(userId)) favoriteUserIds = favoriteUserIds.filter(id => id !== userId);
            else favoriteUserIds.push(userId);

            localStorage.setItem('favoriteUserIds', JSON.stringify(favoriteUserIds));
            this.favoriteUserIds = favoriteUserIds;
        },
        handleUserSelected(event) {
            const users = this.users.filter(user => {
                if (!this.manuallySelectedUserIds.includes(user.id)) return false;
                if (user.id === this.you?.id) user.isYou = true;
                return user;
            });

            this.gameUsers = users;
        },
        async handleStartGame() {
            if(this.allGameUsers.length < 3) return

            const users = this.allGameUsers
                .filter(user => user.name)
                .map(user => {
                    return {
                        id: user.id,
                        name: user.name,
                    }
                });
            const createdGame = await httpRequest('POST', '/games', { users });
            this.$emit('gameCreated', createdGame);
        },
        focusNextInput() {
            this.selectingUserId = null;
            this.suggestedUsers = [];
            const inputs = document.getElementsByClassName('name-input');
            const lastInput = inputs[inputs.length-1];
            lastInput.focus();
        }
    },
    computed: {
        userOptions: function() {
            return this.users
                .filter(user => user.id !== this.you?.id)
                .map(user => {
                    return {
                        label: user.name,
                        value: user.id,
                        base64avatar: user.base64avatar,
                        favorite: this.favoriteUserIds.includes(user.id)
                    }
                })
                .sort((a, b) => a.favorite && !b.favorite ? -1 : 0);
        },
        allGameUsers: function() {
            return [ ...this.gameUsers,...this.newGameUsers ];
        }
    },
    created() {
        let you = localStorage.getItem('you');
        if (!you) return;
        this.you = JSON.parse(you);

        let favoriteUserIds = localStorage.getItem('favoriteUserIds');
        if (favoriteUserIds) favoriteUserIds = JSON.parse(favoriteUserIds);
        else favoriteUserIds = [];
        this.favoriteUserIds = favoriteUserIds;
        
        this.manuallySelectedUserIds = [ this.you.id ];
        console.log('created')
        this.handleUserSelected();
    }
}
</script>

<style lang="scss" scoped>

.game-users {
    padding-block: 12px;

    .actions-bar {
        display: flex;
        gap: 12px;

        .custom-select {
            flex-grow: 1;
        }

        .custom-button {
            width: 30% !important;
        }
    }

    .game-user {
        display: flex;
        justify-content: space-between;
        gap: 16px;
        width: 100%;
        transition: .2s ease;

        .custom-input {
            flex-grow: 1;
            position: relative;
            display: flex;
            gap: 4px;
            padding: .4em .8em;
            border-radius: .8em;
            background: #f1f1f1;
            isolation: isolate;
            user-select: none;
            transition: scale .2s ease;

            .name {
                font-size: 16px !important;
                font-weight: 500;
            }

            &:focus-within {
                scale: 1.05;

                .suggested-users {
                    display: flex;
                    scale: 1;
                    opacity: 1;
                    pointer-events: all;
                }
            }

            .suggested-users {
                display: none;
                opacity: 0;
                scale: 0;
                transform-origin: bottom center;
                pointer-events: none;
                transition: .2s ease;

                position: absolute;
                bottom: 40px;
                left: 0;
                width: 100%;
                max-height: 22vh;
                overflow-y: auto;

                display: flex;
                flex-direction: column-reverse;
                gap: 4px;

                &:active {
                    opacity: 1;
                    pointer-events: all;
                }
                
                .suggested-user {
                    padding: 6px 12px;
                    font-weight: 600;
                    background-color: #f1f1f1;
                    border-radius: 8px;
                    box-shadow: 0 2px 6px -2px black;
                    color: black;

                    background: linear-gradient(90deg, lightgrey 0% 50%, #f1f1f1 50% 100%);
                    background-repeat: no-repeat;
                    background-size: 200%;
                    background-position: 100%;
                    transition: background-position 1.5s cubic-bezier(.28,.64,.45,1);
                    
                    &.selecting {
                        background-position: 0%;
                    }
                }
            }

            .name-input {
                display: block;
                width: 100%;
                height: 20px;
                border: none;
                padding: 0;
                outline: none;
                color: #2f343a;
                background: none;

                &.existing-user {
                    font-weight: 700;
                }
            }

            .remove-icon {
                width: 24px;
                height: 24px;
                margin: -2px;
                
                .ionicon {
                    width: 24px;
                    height: 24px;
                    fill: red;
                }
            }
        }
    }
}

.start-game-button {
    display: grid;
    place-items: center;
    color: #f1f1f1;
    // background-color: #4B9E09;
    background: linear-gradient(153deg, #4B9E09 0% 49%, #449204 51% 100%);
    padding: 4px 10px;
    border-radius: 8px;
    font-weight: 600;
    transition: .2s ease;
    text-shadow: 1px 1px 2px #035300;
    user-select: none;
}

.blur-focus {
    isolation: isolate;
    &:after {
        content: "";
        position: absolute;
        inset: -100vh;
        transition: .15s ease;
        pointer-events: none;
        z-index: -1;
    }
    &.enabled:focus,
    &.enabled:focus-within,
    &.mousedown {
        z-index: 1;
        &:after {
            -webkit-backdrop-filter: blur(.5px) brightness(80%);
            backdrop-filter: blur(.5px) brightness(80%);
            transition: 1s cubic-bezier(.15,.75,.2,1);
        }
    }
}

.slide-inputs-enter-active {
    --margin-top: -44px;
    animation: slideIn .3s ease forwards;
    z-index: -1;
}
.slide-inputs-leave-active {
    --margin-top: -44px;
    animation: slideOut .2s ease forwards;
    z-index: -1;
}

@keyframes slideIn {
    from {
        scale: 0.5;
        opacity: 0;
        margin-top: var(--margin-top);
    } to {
        scale: 1;
        opacity: 1;
        margin-top: 0;
    }
}
@keyframes slideOut {
    from {
        scale: 1;
        opacity: 1;
        margin-top: 0;
    } to {
        scale: 0.5;
        opacity: 0;
        margin-top: var(--margin-top);
    }
}
</style>